<template>
  <div class="pay">
    <div class="pay-title gray">消费币金额</div>
    <div class="pay-money"><span class="pay-signal" style="font-size: initial">¥</span>{{ money.toFixed(2) }}</div>
    <nut-radiogroup v-model="payGroup" class="pay-group">
      <nut-radio class="pay-radio" label="0">
        <div class="pay-name">微信支付</div>
      </nut-radio>
      <nut-radio class="pay-radio" label="1">
        <div class="pay-name">余额(剩余{{ coin }}消费币)</div>
        <span class="pay-recharge" @click="toRecharge">去充值</span>
      </nut-radio>
    </nut-radiogroup>
    <div class="pay-btn" @click="confirm">确认支付</div>
  </div>
</template>

<script>
import { Toast } from '@nutui/nutui'
import { UpgradeHallLevel } from '@/api/Personal/Hall'

export default {
  name: 'Index',
  data() {
    return {
      payGroup: '1',
      money: 999,
      coin: 500,
      id: 0,
      levelId: 0
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.levelId = this.$route.params.levelId
  },
  methods: {
    toRecharge() {
      this.$router.push({
        name: 'MoneyPay'
      })
    },
    confirm() {
      if (this.coin < this.money) {
        Toast.fail('余额不足，请充值')
      } else {
        UpgradeHallLevel(this.id, this.levelId).then(res => {
          if (res.success) {
            this.$router.replace({
              name: 'PaySuccess'
            })
          } else {
            this.$router.replace({
              name: 'PayFail'
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pay {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .pay-title {
    margin-top: 150px;
  }

  .pay-money {
    margin-top: 20px;
    font-size: 28px;
    font-family: Impact, sans-serif;
    font-weight: bolder;
    color: $primary-color;

    .pay-signal {
      margin-right: 5px;
      font-family: sans-serif;
    }
  }

  .pay-group {
    margin: 50px 15px 100px;
    width: 70vw;
    display: flex;
    flex-direction: column;

    ::v-deep .nut-radio {
      height: 50px;
      line-height: 50px;
      position: relative;
    }

    .pay-radio {
      position: relative;
      z-index: 10;

      .pay-name {
        position: absolute;
        width: 145px;
        height: 50px;
        line-height: 50px;
        top: 0;
        left: 25px;
      }

      .pay-recharge {
        position: absolute;
        text-align: center;
        width: 70px;
        height: 28px;
        line-height: 28px;
        top: 11px;
        left: 200px;
        border-radius: 2px;
        color: $primary-color;
        border: 1px solid $primary-color;
      }
    }

    ::v-deep .nut-radio:first-child::after {
      position: absolute;
      content: '';
      left: 0;
      top: auto;
      bottom: 0;
      right: auto;
      height: 1px;
      width: 100%;
      background-color: $border-color;
    }

    ::v-deep input {
      border-width: 1px;
      line-height: 50px;
    }

    ::v-deep input:checked {
      background-color: #f9bc38;
      border-color: #f9bc38;
    }
  }

  .pay-btn {
    width: 278px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-weight: bold;
    background: linear-gradient(to right, #f2a612, #f7c827);
    border-radius: 5px;
    letter-spacing: 5px;
    text-indent: 5px;
    text-align: center;
  }
}
</style>
